<template>
  <div class="left side-menu" v-bind:class="{ 'hide-left-sidebar': !auth.isLoggedIn }">
    <button type="button" class="button-menu-mobile button-menu-mobile-topbar open-left waves-effect" @click="clickInMobileMenu()">
      <i class="ion-close"></i>
    </button>

    <!-- LOGO -->
    <div class="topbar-left">
      <div class="text-center">
        <router-link to="/" class="logo">
          <img src="../assets/img/logo.png" height="52" alt="logo">
        </router-link>
      </div>
    </div>

    <template  v-if="auth.isLoggedIn">
      <div class="slimScrollDiv">
        <div class="sidebar-inner slimscrollleft">

          <div class="user-details">
            <div class="text-center">
              <img src="../assets/img/default-avatar.png" alt="" class="rounded-circle">
            </div>
            <div class="user-info">
              <h4 class="font-16"><span v-if="auth.user.displayName">{{ auth.user.displayName }}</span><br v-if="auth.user.displayName"/>{{ auth.user.email }}</h4>
              <span class="text-muted user-status"><i class="fa fa-dot-circle-o text-success"></i> Online</span>
            </div>
          </div>

          <div id="sidebar-menu">
            <ul>
              <li>
                <router-link to="/" class="waves-effect" exact>
                  <i class="mdi mdi-view-dashboard"></i>
                  <span> Escritorio </span>
                </router-link>
              </li>

              <li v-check-permission="'registration-to-careers'" v-if="auth.user && auth.user.role && auth.user.role.isDefault">
                <router-link to="/registration-to-careers" class="waves-effect">
                  <i class="fa fa-folder-open"></i> <span> Inscripción a carreras </span>
                </router-link>
              </li>

              <li v-check-permission="'list-users'">
                <router-link to="/users" class="waves-effect"><i class="fa fa-users"></i> <span> Usuarios </span> </router-link>
              </li>

              <li v-check-permission="'list-roles'">
                <router-link to="/roles" class="waves-effect"><i class="fa fa-sitemap"></i> <span> Roles </span> </router-link>
              </li>

              <li v-check-permission="'list-careers'">
                <router-link to="/careers" class="waves-effect"><i class="fa fa-university"></i> <span> Carreras </span> </router-link>
              </li>

              <li v-check-permission="'list-payments'">
                <router-link to="/list-payments" class="waves-effect"><i class="fa fa-money"></i> <span> Pagos </span> </router-link>
              </li>

              <li v-check-permission="'list-user-payments'" v-if="auth.user && auth.user.role && auth.user.role.isDefault">
                <router-link to="/list-user-payments" class="waves-effect"><i class="fa fa-money"></i> <span> Pagos </span> </router-link>
              </li>

              <li v-check-permission="'sync-permissions'">
                <router-link to="/permission-manager" class="waves-effect"><i class="fa fa-unlock-alt"></i> <span> Sincronizar permisos </span> </router-link>
              </li>

              <li v-check-permission="'list-registration-to-careers'">
                <router-link to="/list-registration-to-careers" class="waves-effect"><i class="fa fa-book"></i> <span> Inscripción a las carreras</span> </router-link>
              </li>

              <li v-check-permission="'list-examination-tables'">
                <router-link to="/examination-tables" class="waves-effect"><i class="fa fa-book"></i> <span>Mesas de exámen</span> </router-link>
              </li>

              <li v-check-permission="'registration-to-examination-tables'">
                <router-link to="/registration-to-examination-tables" class="waves-effect"><i class="fa fa-book"></i> <span>Inscripción a mesas de exámen</span> </router-link>
              </li>

              <li v-check-permission="'list-registration-to-examination-tables'">
                <router-link to="/list-of-registration-to-examination-tables" class="waves-effect"><i class="fa fa-book"></i> <span>Listas de inscriptos a mesas de exámen</span> </router-link>
              </li>

              <li v-check-permission="'list-stock-of-ambos'">
                <router-link to="/list-stock-of-ambos" class="waves-effect"><i class="fa fa-book"></i> <span> Stock de ambos</span> </router-link>
              </li>

              <li v-check-permission="'list-delivery-of-ambos'">
                <router-link to="/list-delivery-of-ambos" class="waves-effect"><i class="fa fa-book"></i> <span> Entrega de ambos</span> </router-link>
              </li>

              <li class="has_sub" v-check-permission="'manage-config'">
                <a href="javascript:void(0);" class="waves-effect"><i class="fa fa-gear"></i> <span> Configuración </span> </a>
                <ul class="list-unstyled">
                  <li>
                    <router-link to="/config" class="waves-effect"><i class="fa fa-gear"></i> <span> Inscripcion ingresantes </span> </router-link>
                    <router-link to="/payment-rules-for-fee" v-check-permission="'list-payment-rules'" class="waves-effect"><i class="fa fa-gear"></i> <span> Reglas para cuotas </span> </router-link>
                    <router-link to="/payment-rules-for-tuition" v-check-permission="'list-payment-rules'" class="waves-effect"><i class="fa fa-gear"></i> <span> Reglas para matricula </span> </router-link>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  // import Auth from '../auth'

  export default {
    name: 'app-sidebar',


    created () {
      //Obtenemos todas las configuraciones del sistema
      this.getAllConfigurations()
    },


    data () {
      return {
        auth: this.$store.state.auth
      }
    },


    computed: {

      mobileMenuIsActive: function () {
        return this.$store.getters.getMobileMenuStatus
      },

      //traemos la configuracion para saber si el formulario de inscripcion a las carreras esta activo
      configItemRegistrationToCareersIsActive: function () {
        return (this.$store.getters.getConfigByKey('registrationToCareers.active') ? Boolean(this.$store.getters.getConfigByKey('registrationToCareers.active').value) : false)
      },

      //traemos la configuracion para saber si el formulario de inscripcion a las carreras esta activo
      configItemRegistrationToCareersAcademicYear: function () {
        return (this.$store.getters.getConfigByKey('registrationToCareers.academicYear') ? this.$store.getters.getConfigByKey('registrationToCareers.academicYear').value : '')
      },

      //Comprobamos si tiene permisos para registrarse a las carreras y si el formulario  de inscripcion esta activo
      showRegistrationToCareers: function () {
        const role = this.auth.user.role

        if(role && role.isDefault && this.$acl.checkPermission('registration-to-careers')) {
          if ( this.configItemRegistrationToCareersIsActive ) {
            return true
          }
        }

        return false
      }

    },


    methods: {

      clickInMobileMenu () {
        this.$store.dispatch('showMobileMenu', { show: !this.mobileMenuIsActive })
      },

      getAllConfigurations: function () {

        this.$store.dispatch('getAllConfigurations')
          .then((response) => {

          })
          .catch((response) => {
            this.error = response.message
          })
      }

    }
  }
</script>

<style scoped>
  .user-info .font-16 {
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden
  }
  .hide-left-sidebar {
    left: -300px;
  }
  #sidebar-menu > ul > li > a.router-link-active {
    background-color: #e1e3e9;
  }
  .slimscrollleft {
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppSidebar.vue